import { Button, ButtonProps } from '@chakra-ui/react';

interface ChipProps extends Omit<ButtonProps, 'variant'> {
  active?: boolean;
}

/** DS chip — pill toggle (design-guidelines.md §4). */
export const Chip = ({ active, children, ...rest }: ChipProps) => (
  <Button
    h='30px'
    px={3}
    color={active ? 'primary.solid' : 'text.muted'}
    fontSize='sm'
    fontWeight={500}
    bg={active ? 'primary.soft' : 'bg.surface'}
    borderWidth='1px'
    borderColor={active ? 'primary.solid' : 'border.strong'}
    borderRadius='full'
    _hover={{ borderColor: 'primary.solid', color: 'primary.solid' }}
    {...rest}
  >
    {children}
  </Button>
);

export default Chip;
